import { TPayoutView } from "../bloc/payoutViewSlice";

export interface PayoutViewDataResponse {
    utr: string;
    createdOn: string;
    type: string;
    receiver: string;
    txnAmt: number;
    payoutId: string;
    txnStatus: string;
    pmtMode: string;
    benCode: string;
    timeStamp: string;
    statusDesc: string;
    narration: string;
    customerName: string;
    vaId: string;
    collectDesc: string;
    comments: string,
    pmtRefId: string,
}


export const mapPayoutViewResponseToModel = (data: PayoutViewDataResponse) => {

    let payoutView = {
        utr: data.utr,
        debitFrom: "Axis Bank",
        createdOn: data.createdOn,
        purpose: data.type,
        paymentMode: data.pmtMode,
        amount: data.txnAmt,
        payoutId: data.payoutId,
        status: data.txnStatus,
        narration: data.narration,
        transactionDateTime: data.timeStamp,
        collectDesc: data.collectDesc,
        comments: data.comments,
        pmtRefId: data.pmtRefId
    };
    return payoutView;
}

export const mapCollectionViewResponseToModel = (data: PayoutViewDataResponse) => {

    let payoutView = {
        utr: data.utr,
        debitFrom: "Axis Bank",
        createdOn: data.createdOn,
        customerName: data.customerName,
        paymentMode: data.pmtMode,
        amount: data.txnAmt,
        vaId: data.vaId,
        status: data.txnStatus,
        collectDesc: data.collectDesc,
        comments: data.comments,
        pmtRefId: data.pmtRefId
    };
    return payoutView;
}

export type PayoutPmtStatus = {
    cropCode: string,
    statusDescription: string,
    batchNo: string,
    utrNo: string,
    processingDate: string,
    responeCode: string,
    crn: string,
    transactionStatus: string,
    transaction_id: string,
    responseCode: string,
    paymentMode: string,
    vendorCode: string,
    amount: string,
    corporateAccountNumber: string,
    debitCreditIndicator: string,
    beneficiaryAccountNumber: string
}